import { render } from "./MessengerHeader.vue?vue&type=template&id=363ed2f0&scoped=true"
import script from "./MessengerHeader.vue?vue&type=script&lang=js"
export * from "./MessengerHeader.vue?vue&type=script&lang=js"

import "./MessengerHeader.vue?vue&type=style&index=0&id=363ed2f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-363ed2f0"]])

export default __exports__